'use client'

/**
 * Herlogin-flow bij een verlopen sessie (FO-374 C) - portal-variant.
 *
 * Verschijnt zodra `markSessionExpired()` is aangeroepen (een authed badge-poll
 * zag een 401/403). Mobile-first bottom-sheet met safe-area; z-[60] conform de
 * portal z-index-ladder (modals/sheets). Een volledige navigatie naar /login
 * gooit de stale client-state weg en start de herauthenticatie.
 */
import { useSessionExpired } from '@/lib/session-expired'

export function SessionExpiredNotice() {
  const expired = useSessionExpired()
  if (!expired) return null

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-desc"
      className="fixed inset-0 z-[60] flex items-end justify-center bg-black/50 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] sm:items-center"
    >
      <div className="w-full max-w-sm rounded-2xl border border-streep-border bg-streep-surface p-6 shadow-xl">
        <h2 id="session-expired-title" className="text-lg font-bold text-streep-donker">
          Sessie verlopen
        </h2>
        <p id="session-expired-desc" className="mt-2 text-sm text-streep-text-muted">
          Je bent uitgelogd of je sessie is verlopen. Log opnieuw in om verder te gaan.
        </p>
        <a
          href="/login"
          className="mt-5 inline-flex min-h-11 w-full items-center justify-center rounded-xl bg-streep-groen px-4 text-sm font-semibold text-streep-donker transition-opacity hover:opacity-90"
        >
          Opnieuw inloggen
        </a>
      </div>
    </div>
  )
}
